<template>
    <div class="loading" :style="{ minHeight: minHeight + 'px' }">
        <div class="ball"></div>
    </div>
</template>

<script>
export default {
    props: {
        minHeight: {
            type: [String, Number],
            default: '100',
        },
    },
}
</script>

<style lang="less" scoped>
.loading {
    width: 100%;
    height: 100%;
    position: relative;
    .ball {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: @primary-color;
        border-radius: 50%;
        animation: mychange 1s infinite;
    }
}
@keyframes mychange {
    0% {
        width: 1px;
        height: 1px;
        opacity: 1;
    }
    100% {
        width: 30px;
        height: 30px;
        opacity: 0;
    }
}
</style>
